// React
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// Bootstrap
import { Container, Row, Col } from "react-bootstrap";

import EntityPortal from "../entityPortal";
// Styles
import "./index.scss";
import AppConfig from "../../helpers/appConfig";
import PageTemplate from "../PageTemplate";
import PageTitle from "../../components/PageTitle";
import { fetchOrganizationEnities } from "../../redux/actions/entityPortalAction";
import Loader from "../../components/Loader";
import { fetchSignOut } from "../../redux/actions/signOutAction";

const PeopleReportView = ({ intl, ...props }) => {
  const loginStates = useSelector((state) => state.logins);
  const [peopletabExist, setPeopleTabExist] = useState(true);
  const [organizationEnitiesState, setOrganizationEnitiesState] =
    useState(null);
  const [component, setComponent] = useState(
    AppConfig.fetchComponentsByPageId(
      "entityMemberPortal",
      "entityPortal",
      "people",
      "projects",
      "ballots",
      "groups"
    )
  );
  const [customFilters, selectedCustomFilters] = useState({
    organizationvalue: "",
  });
  const [isVisible, setIsVisible] = useState(false);
  const dispatch = useDispatch();
  const organizatiinEnitiesData = useSelector(
    (state) => state.entityData.enitiesData
  );
  const isOrganizationCalled = useSelector(
    (state) => state.entityData.isOrganizationCalled
  );
  useEffect(() => {
    if (loginStates?.login?.data?.userDetails.length > 0) {
      let userdetailsCopy = loginStates.login.data.userDetails;
      userdetailsCopy = userdetailsCopy.sort((a, b) => {
        if (
          a.organizationName?.toLowerCase() < b.organizationName?.toLowerCase()
        ) {
          return -1;
        }
        if (
          a.organizationName?.toLowerCase() > b.organizationName?.toLowerCase()
        ) {
          return 1;
        }
        return 0;
      });
      const internalId = userdetailsCopy[0].internalId;
      const staff = loginStates.login.data.staff;
      const membershipStaff = loginStates.login.data.memberStaff;
      // Normalize once; null-safe so a missing contactType cannot throw and
      // break the role effect.
      const contactType = (userdetailsCopy[0].contactType || "").toLowerCase();
      // EMR (Keycontact) and EMRA roles. Users holding these roles must always
      // see the People tab; this role overrides any exclusion rule below.
      const keyContactValues = [
        "keycontact",
        "entity member representative alternate",
      ];
      const isEMR =
        staff &&
        staff.toLowerCase() === "n" &&
        keyContactValues.includes(contactType);
      selectedCustomFilters((prevCustomFilters) => {
        return {
          ...prevCustomFilters,
          internalId: internalId,
        };
      });
      dispatch(fetchOrganizationEnities(internalId, true));
      if (component?.length && component[0]?.SUBCOMPONENTS) {
        component[0].SUBCOMPONENTS.forEach((item) => {
          if (item.name === "entity-table") {
            const newApiURL = item.apiURL.substring(26, 0);
            item.apiURL = `${newApiURL}/${internalId}`;
          }
        });
      }
      if (component?.length && component[1]?.SUBCOMPONENTS) {
        component[1].SUBCOMPONENTS.forEach((item) => {
          if (item.name === "projects-table") {
            const newApiURL = item.apiURL.substring(41, 0);
            item.apiURL = `${newApiURL}/${internalId}`;
          }
        });
      }
      if (component?.length && component[2]?.SUBCOMPONENTS) {
        component[2].SUBCOMPONENTS.forEach((item) => {
          if (item.name === "ballots-table") {
            const newApiURL = item.apiURL.substring(49, 0);
            item.apiURL = `${newApiURL}/${internalId}`;
          }
        });
      }
      if (component?.length && component[3]?.SUBCOMPONENTS) {
        component[3].SUBCOMPONENTS.forEach((item) => {
          if (item.name === "group-table") {
            const newApiURL = item.apiURL.substring(48, 0);
            item.apiURL = `${newApiURL}/${internalId}`;
          }
        });
      }
      if (
        membershipStaff &&
        membershipStaff.toLowerCase() === "y" &&
        staff &&
        staff.toLowerCase() === "y"
      ) {
        const filteredEditDisabledData = component;
        filteredEditDisabledData.forEach((item) => {
          if (item._uid === "ballots" || item._uid === "groups") {
            item.SUBCOMPONENTS.forEach((item2) => {
              if (item2.type === "table") {
                item2.COLUMNS = item2.COLUMNS.filter(
                  (item3) => item3.image !== "editpenview"
                );
              }
            });
          }
        });
        setComponent(filteredEditDisabledData);
        setIsVisible(false);
      } else if (
        membershipStaff &&
        membershipStaff.toLowerCase() === "n" &&
        staff &&
        staff.toLowerCase() === "y"
      ) {
        //Staff (non-member-staff): show People tab and strip edit pen from ballots/groups
        const filteredEditDisabledData = component;
        filteredEditDisabledData.forEach((item) => {
          if (item._uid === "ballots" || item._uid === "groups") {
            item.SUBCOMPONENTS.forEach((item2) => {
              if (item2.type === "table") {
                item2.COLUMNS = item2.COLUMNS.filter(
                  (item3) => item3.image !== "editpenview"
                );
              }
            });
          }
        });
        setComponent(filteredEditDisabledData);
        setIsVisible(false);
      } else if (isEMR) {
        //EMR(Keycontact) / EMRA: always show the People tab (overrides all exclusions)
        const filteredEditDisabledData = component;
        setComponent(filteredEditDisabledData);
        setIsVisible(false);
      } else if (
        staff &&
        staff.toLowerCase() === "n" &&
        contactType === "complimentary individual member"
      ) {
        //Any portal user sees the People tab; strip edit pen from ballots/groups
        const filteredEditDisabledData = component;
        filteredEditDisabledData.forEach((item) => {
          if (item._uid === "ballots" || item._uid === "groups") {
            item.SUBCOMPONENTS.forEach((item2) => {
              if (item2.type === "table") {
                item2.COLUMNS = item2.COLUMNS.filter(
                  (item3) => item3.image !== "editpenview"
                );
              }
            });
          }
        });
        setComponent(filteredEditDisabledData);
        setIsVisible(false);
      } else if (staff && staff.toLowerCase() === "y") {
        //Staff: show People tab and strip edit pen from ballots/groups
        const filteredEditDisabledData = component;
        filteredEditDisabledData.forEach((item) => {
          if (item._uid === "ballots" || item._uid === "groups") {
            item.SUBCOMPONENTS.forEach((item2) => {
              if (item2.type === "table") {
                item2.COLUMNS = item2.COLUMNS.filter(
                  (item3) => item3.image !== "editpenview"
                );
              }
            });
          }
        });
        setComponent(filteredEditDisabledData);
        setIsVisible(false);
      } else if (
        staff &&
        staff.toLowerCase() === "n" &&
        contactType === "billing contact"
      ) {
        //Billing contact without EMR role: People tab remains hidden
        setIsVisible(true);
      } else {
        const filteredEditDisabledData = component;
        filteredEditDisabledData.forEach((item) => {
          if (item._uid === "ballots" || item._uid === "groups") {
            item.SUBCOMPONENTS.forEach((item2) => {
              if (item2.type === "table") {
                item2.COLUMNS = item2.COLUMNS.filter(
                  (item3) => item3.image !== "editpenview"
                );
              }
            });
          }
        });
        setComponent(filteredEditDisabledData);
        setIsVisible(false);
      }
    }
  }, []);

  useEffect(() => {
    if (organizatiinEnitiesData && organizatiinEnitiesData.data) {
      setOrganizationEnitiesState(organizatiinEnitiesData.data);
    }
  }, [organizatiinEnitiesData]);

  useEffect(() => {
    if (customFilters.organizationvalue) {
      dispatch(fetchOrganizationEnities(customFilters.organizationvalue, true));
    }
    if (customFilters.organizationvalue) {
      const componentCopy = component;
      if (componentCopy.length) {
        if (componentCopy[0]?.SUBCOMPONENTS && peopletabExist) {
          componentCopy[0].SUBCOMPONENTS.forEach((item) => {
            if (item.name === "entity-table") {
              const newApiURL = item.apiURL.substring(26, 0);
              item.apiURL = `${newApiURL}/${customFilters.organizationvalue}`;
            }
          });
        }
        if (componentCopy[peopletabExist ? 1 : 0]?.SUBCOMPONENTS) {
          componentCopy[peopletabExist ? 1 : 0].SUBCOMPONENTS.forEach(
            (item) => {
              if (item.name === "projects-table") {
                const newApiURL = item.apiURL.substring(28, 0);
                item.apiURL = `${newApiURL}/${customFilters.organizationvalue}`;
              }
            }
          );
        }
        if (componentCopy[peopletabExist ? 2 : 1]?.SUBCOMPONENTS) {
          componentCopy[peopletabExist ? 2 : 1].SUBCOMPONENTS.forEach(
            (item) => {
              if (item.name === "ballots-table") {
                const newApiURL = item.apiURL.substring(36, 0);
                item.apiURL = `${newApiURL}/${customFilters.organizationvalue}`;
              }
            }
          );
        }
        if (componentCopy[peopletabExist ? 3 : 2]?.SUBCOMPONENTS) {
          componentCopy[peopletabExist ? 3 : 2].SUBCOMPONENTS.forEach(
            (item) => {
              if (item.name === "group-table") {
                const newApiURL = item.apiURL.substring(35, 0);
                item.apiURL = `${newApiURL}/${customFilters.organizationvalue}`;
              }
            }
          );
        }
        setComponent([...component, componentCopy]);
      }
    }
  }, [customFilters.organizationvalue]);
  const signOutUser = () => {
    dispatch(fetchSignOut(props));
  };

  return (
    <>
      {
        <div className="page-content details-content-container">
          <PageTitle
            label="peopleReportView"
            fullName={loginStates?.login?.data?.profileName}
            onSignOutUser={signOutUser}
          />
          {isOrganizationCalled && (
            <EntityPortal
              selectedCustomFilters={selectedCustomFilters}
              userDetails={loginStates.login.data.userDetails}
              data={organizationEnitiesState ? organizationEnitiesState : []}
              customFilters={customFilters}
              loginStates={loginStates}
            />
          )}
          {!isVisible && (
            <Container fluid className="px-0 mt-4">
              <Row className="mx-0">
                <Col className="px-0">
                  {organizationEnitiesState &&
                    (customFilters.internalId || customFilters.roleCode) && (
                      <PageTemplate type="tabs" content={component} />
                    )}
                </Col>
              </Row>
              {loginStates?.isLoader && <Loader globalWrap={true} />}
            </Container>
          )}
        </div>
      }
    </>
  );
};

export default PeopleReportView;